import { render } from "./NoFoundPage.vue?vue&type=template&id=89731c4a&scoped=true&ts=true"
import script from "./NoFoundPage.vue?vue&type=script&lang=ts"
export * from "./NoFoundPage.vue?vue&type=script&lang=ts"

import "./NoFoundPage.vue?vue&type=style&index=0&id=89731c4a&lang=scss&scoped=true"

import exportComponent from "D:\\J\\workspace\\FusionServer\\QUA\\Manitou.FusionServer.Web.DiagPortalFront\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89731c4a"]])

export default __exports__